export enum Crit {
    Internet,
    Ac,
    Pool,
    Dishwasher,
    Fireplace,
    Jacuzzi,
    Parking,
    Pets,
    Sauna,
    Tv,
    WashingMachine,
    NoSmoking,
    Wheelchairs,
    LastMinute,
    BedroomFrom1,
    BedroomFrom2,
    BedroomFrom3,
    BedroomFrom4,
    PersonsFrom2,
    PersonsFrom3,
    PersonsFrom4,
    PersonsFrom5,
    PersonsFrom6,
    PersonsFrom7,
    PersonsFrom8,
    PersonsFrom9,
    PersonsFrom10,
    WaterTill250,
    WaterTill500,
    WaterTill1000,
    WaterTill10000,
    SkiliftTill250,
    SkiliftTill500,
    SkiliftTill1000,
    SkiliftTill10000,
    TypeHolidayhome,
    TypeApartment,
}
